import { render, staticRenderFns } from "./circularChart.vue?vue&type=template&id=007a2203&scoped=true"
import script from "./circularChart.vue?vue&type=script&lang=js"
export * from "./circularChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "007a2203",
  null
  
)

export default component.exports